import type { DetailsHTMLAttributes, ReactNode } from 'react';

interface DisclosureProps extends Omit<DetailsHTMLAttributes<HTMLDetailsElement>, 'children' | 'title'> {
  title: ReactNode;
  meta?: ReactNode;
  children: ReactNode;
  bodyClassName?: string;
}

/** Shared low-emphasis disclosure with one consistent chevron and spacing. */
export function Disclosure({
  title,
  meta,
  children,
  className = '',
  bodyClassName = '',
  ...props
}: DisclosureProps) {
  return (
    <details className={`disclosure${className ? ` ${className}` : ''}`} {...props}>
      <summary>
        <span className="disclosure-title">{title}</span>
        {meta ? <span className="disclosure-meta">{meta}</span> : null}
      </summary>
      <div className={`disclosure-body${bodyClassName ? ` ${bodyClassName}` : ''}`}>{children}</div>
    </details>
  );
}
